import { useMutation } from "@tanstack/react-query";

import type { LogEntry } from "@apis/calorie-grid/models";

import { logEntryRepository } from "../../../repository/LogEntryRepository.ts";
import { useLogEntryActions } from "../../../shared/hooks/useLogEntryActions.ts";

// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
export function usePlacementGridActions() {
  const { invalidateLogEntries } = useLogEntryActions();
  const removeFromGrid = useMutation({
    mutationFn: async (logEntry: LogEntry): Promise<void> => {
      await logEntryRepository.update(logEntry, {
        cells: null,
        status: "pending",
      });
    },
    onSuccess: invalidateLogEntries,
  });

  return { removeFromGrid };
}
